import React, { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import styles from '../styles/profile-header.module.scss'
import { capitalizeEachWord } from 'utils'
import HeadToHead from '../../head-to-head/H2HModal'
import classNames from 'classnames'
import { ConnectedVsSearch, PLAYER_SEARCH_2 } from 'components/search/VsPlayerSearchBar'
import { useDispatch, useSelector } from 'react-redux'
import { selectLoadedProfile } from 'redux/selectors'
import { updateVsPlayerIds } from 'actions/h2h-actions'
import { useProfileParams } from '../ProfileRouter/hooks'
import { QueryParamNames } from 'types/global'

interface Props {
  name?: string
  vsPlayerIds: [string, string]
  showWtnHistory?: boolean
  hideResultsForAnonUser?: boolean
}

const HeadToHeadTab = ({
  vsPlayerIds,
  name,
  showWtnHistory = false,
  hideResultsForAnonUser = false,
}: Props) => {
  const { t: tMatchHistory } = useTranslation('strMatchHistory')
  const { t: tRecentOpponents } = useTranslation('strRecentOpponents')
  const dispatch = useDispatch()
  const profileViewed = useSelector(selectLoadedProfile)
  const { vsPlayerId, setQueryParams } = useProfileParams()

  useEffect(() => {
    if (profileViewed?.id && vsPlayerId) {
      dispatch(updateVsPlayerIds([profileViewed.id, vsPlayerId]))
    }
  }, [vsPlayerId, profileViewed, dispatch])

  return (
    <div className={styles.tabContentWrapper}>
      <h1 className={classNames(styles.tabContentTitle, styles.tabContentTitleH2H)}>
        {tMatchHistory('headToHead')}
      </h1>
      <p className={styles.h2hTabIntroParagraph}>
        <Trans ns='strProfile' i18nKey='h2hSearchDescription'>
          Select players to compare{' '}
          <strong>
            {{ name: name ? capitalizeEachWord(name) : tRecentOpponents('thisPlayer') }}
          </strong>{' '}
          to
        </Trans>
      </p>
      <div className={styles.searchBarBg}>
        <ConnectedVsSearch
          searchId={PLAYER_SEARCH_2}
          onSearchIndividual={id => {
            setQueryParams({ [QueryParamNames.PROFILE_H2H_OPPONENT_ID]: id })
          }}
        />
      </div>

      <HeadToHead
        playerIds={vsPlayerIds}
        showWtnHistory={showWtnHistory}
        hideResultsForAnonUser={hideResultsForAnonUser}
      />
    </div>
  )
}

export default HeadToHeadTab
